export const SET_ACTIONS = 'SET_ACTIONS';
export const SET_ACTION = 'SET_ACTION';
export const ADD_ACTION = 'ADD_ACTION';
export const UPDATE_ACTION = 'UPDATE_ACTION';
export const REMOVE_ACTION = 'REMOVE_ACTION';
export const CLEAR_ACTION = 'CLEAR_ACTION';
export const CLEAR_ACTIONS = 'CLEAR_ACTIONS';
